/* eslint-disable max-len */
/* eslint-disable no-plusplus */
// libraries
import React from 'react';
import {
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from '@material-ui/core';
import { CheckCircle, NavigateBefore, Send } from '@material-ui/icons';
import { v4 as uuidv4 } from 'uuid';

// js
import defaultSound from '../../../assets/images/defaultSound.png';
import { allMenuItems } from './taskConstants';
import {
    ContainerAdjustIconEdit,
    ContainerOptions,
    InputNullSelectedPhoto,
    Logo,
    TitleOption,
} from '../modulesStyles';

// interfaces
import type { DataModuleInterface, SelectedWordForQuestionInterface } from '../modulesInterfaces';
import uploads from '../../../services/uploads';
import tasks from '../../../services/tasks';

const TaskSelectedWordForQuestion = (
    setIdModal: any,
    initialDataTaskSelectedWordForQuestion: SelectedWordForQuestionInterface,
    taskSelectedWordForQuestion: SelectedWordForQuestionInterface,
    setTaskSelectedWordForQuestion: any,
    dataModule: DataModuleInterface,
) => {
    // constants
    const token: any = String(localStorage.getItem('token') || '');
    const adjustMarginBottom = { marginBottom: 10 };
    const adjustButtonLogo = { marginBottom: 25, width: 200 };
    const adjustWidthSelectedActivities = { width: 200 };
    const marginDefault = { marginRight: 10 };

    // methods
    const BackScreenModal = () => {
        setIdModal(1);
        setTaskSelectedWordForQuestion(initialDataTaskSelectedWordForQuestion);
    };

    const CreateTask = async () => {
        const formatOptions = taskSelectedWordForQuestion?.options?.map((e: any) => {
            const option = e;
            delete option.idWrapperTask;
            return option;
        });
        const formatTask: any = {
            ...taskSelectedWordForQuestion,
            options: formatOptions,
            idTask: taskSelectedWordForQuestion.id,
            idModule: dataModule?.id,
        };
        delete formatTask?.id;
        if (formatTask?.idTask) {
            const editTask: any = await tasks.EditTask(formatTask, token);
            if (editTask) {
                BackScreenModal();
            }
        } else {
            delete formatTask?.idTask;
            const createTask: any = await tasks.CreateTask(formatTask, token);
            if (createTask) {
                BackScreenModal();
            }
        }
    };

    const onChangeTitle = (txt: any) => {
        if (txt.target.value.length <= 200) {
            const newDataTask = { ...taskSelectedWordForQuestion, title: txt.target.value };
            setTaskSelectedWordForQuestion(newDataTask);
        }
    };

    const onChangeSubtitle = (txt: any) => {
        if (txt.target.value.length <= 200) {
            const newDataTask = { ...taskSelectedWordForQuestion, subtitle: txt.target.value };
            setTaskSelectedWordForQuestion(newDataTask);
        }
    };

    const onChangeQuestion = (txt: any) => {
        if (txt.target.value.length <= 200) {
            const newDataTask = { ...taskSelectedWordForQuestion, question: txt.target.value };
            setTaskSelectedWordForQuestion(newDataTask);
        }
    };

    const onChangeOptionSkipTask = (txt: any) => {
        const newDataTask = { ...taskSelectedWordForQuestion, skip: txt.target.value };
        setTaskSelectedWordForQuestion(newDataTask);
    };

    const validationDisabled = () => {
        let valueObject = true;
        if (taskSelectedWordForQuestion?.id) {
            const ValidationLength = Object.values(taskSelectedWordForQuestion).filter((v) => v !== '').length !== 10;
            const ValidationOptionsLength = taskSelectedWordForQuestion?.options.filter((v: any) => v.option).length === taskSelectedWordForQuestion?.options?.length;
            if (!ValidationLength && ValidationOptionsLength) {
                valueObject = false;
            }
        } else if (!taskSelectedWordForQuestion?.id) {
            const ValidationLength = Object.values(taskSelectedWordForQuestion).filter((v) => v !== '').length !== 9;
            if (!ValidationLength) {
                valueObject = false;
            }
        }
        return valueObject;
    };

    const validationBackground = () => {
        const valueObject = Object.values(taskSelectedWordForQuestion).filter((v) => v !== '');
        const ValidationOptionsLength = taskSelectedWordForQuestion?.options.filter((v: any) => v.option).length === taskSelectedWordForQuestion?.options?.length;
        if ((taskSelectedWordForQuestion?.id ? valueObject.length === 10 : valueObject.length === 9) && ValidationOptionsLength) {
            return 'primary';
        }

        return 'inherit';
    };

    const onChangeTarget = (txt: any) => {
        const allOptions = [];
        for (let i = 0; i < Number(txt.target.value); i++) {
            const objOrigin = {
                option: '',
                id: uuidv4(),
            };
            allOptions.push(objOrigin);
            if (allOptions.length === Number(txt.target.value)) {
                const orderNewDataOption = allOptions.sort((a, b) => {
                    if (a.id < b.id) return -1;
                    if (a.id > b.id) return 1;
                    return 0;
                });
                const newDataTask = {
                    ...taskSelectedWordForQuestion,
                    target: Number(txt.target.value),
                    options: orderNewDataOption,
                    // correct: orderNewDataOption.filter((v: any) => !v.optionEnglish || !v.optionPortuguese).length > 0 ? '' : taskSelectedWordForQuestion?.correct,
                };
                setTaskSelectedWordForQuestion(newDataTask);
            }
        }
    };

    const onChangeOptionCorrect = (txt: any) => {
        const newDataTask = { ...taskSelectedWordForQuestion, correct: txt.target.value };
        setTaskSelectedWordForQuestion(newDataTask);
    };

    // renders
    const RenderAllOptionsCorrect = () => {
        const AllOptionsEnglish = [] as any;
        const test = taskSelectedWordForQuestion.options.map(
            (v: any) => AllOptionsEnglish.push(v.option),
        );
        if (AllOptionsEnglish.length === test.length) {
            return AllOptionsEnglish.map((option: any) => (
                <MenuItem value={option}>{option}</MenuItem>
            ));
        }

        return null;
    };

    const RenderSelectedCorrectOptions = (skipTask: boolean) => {
        const options = taskSelectedWordForQuestion.options.filter((v: any) => v.option !== '').length;
        const allOptions = options === taskSelectedWordForQuestion.target;

        if (options > 0 && allOptions && !skipTask) {
            const SelectedPhoto = async (event: any) => {
                if (event.target.files.length) {
                    const newDataFiles = {
                        eventFile: event.target.files[0],
                        eventName: event.target.files[0].name,
                        file: URL.createObjectURL(event.target.files[0]),
                    };

                    const upload: any = await uploads.UploadFile(newDataFiles.eventFile);
                    if (upload) {
                        setTaskSelectedWordForQuestion({ ...taskSelectedWordForQuestion, file: upload.result });
                    }
                }
            };

            return (
                <>
                    <FormControl style={adjustWidthSelectedActivities}>
                        <InputLabel>Opção correta</InputLabel>
                        <Select value={taskSelectedWordForQuestion.correct} onChange={onChangeOptionCorrect}>
                            {RenderAllOptionsCorrect()}
                        </Select>
                    </FormControl>
                    <Button
                        style={adjustButtonLogo}
                        title={taskSelectedWordForQuestion?.file}
                    >
                        <Logo src={defaultSound} />
                        {taskSelectedWordForQuestion?.file ? (
                            <ContainerAdjustIconEdit right="40px" style={adjustMarginBottom}>
                                <CheckCircle color="inherit" />
                            </ContainerAdjustIconEdit>
                        ) : null}
                        <InputNullSelectedPhoto
                            accept=".mp3,audio/*"
                            onChange={SelectedPhoto}
                            type="file"
                        />
                    </Button>
                </>
            );
        }
        if (options > 0 && allOptions && skipTask) {
            return (
                <FormControl style={adjustWidthSelectedActivities}>
                    <InputLabel>Pular/Não pular</InputLabel>
                    <Select value={taskSelectedWordForQuestion.skip} onChange={onChangeOptionSkipTask}>
                        <MenuItem value="true">Pular</MenuItem>
                        <MenuItem value="false">Não pular</MenuItem>
                    </Select>
                </FormControl>
            );
        }

        return null;
    };

    const RenderInputsOptions = (label: string, value: string, onChange: any) => {
        const ValueActual = value;
        return (
            <TextField
                fullWidth
                label={`${label} (${ValueActual?.length}/200)`}
                onChange={onChange}
                style={marginDefault}
                value={value}
            />
        );
    };

    const RenderInputsTitles = (label: string, value: string, onChange: any) => {
        const ValueActual = value;
        return (
            <>
                <ContainerOptions marginTop="10px" />
                <TextField
                    fullWidth
                    label={`${label} (${ValueActual?.length}/200)`}
                    onChange={onChange}
                    value={value}
                />
            </>
        );
    };

    const RenderInputsBody = () => {
        if (taskSelectedWordForQuestion.options?.length) {
            return taskSelectedWordForQuestion.options.map((item: any, index: number) => {
                const indexFormat = index + 1;
                const indexZero = indexFormat < 10 ? 0 : '';

                const onChangeOption = (txt: any) => {
                    if (txt.target.value.length <= 200) {
                        const [getOneOption] = taskSelectedWordForQuestion.options.filter(
                            (v: any) => v.id === item.id,
                        );
                        if (getOneOption.id === item.id) {
                            const removeOneOption = taskSelectedWordForQuestion.options.filter(
                                (v: any) => v.id !== item.id,
                            );
                            const optionModified = {
                                option: txt.target.value,
                                id: getOneOption.id,
                            };
                            const newDataOption = [...removeOneOption, optionModified];
                            const orderNewDataOption = newDataOption.sort((a, b) => {
                                if (a.id < b.id) return -1;
                                if (a.id > b.id) return 1;
                                return 0;
                            });
                            setTaskSelectedWordForQuestion({
                                ...taskSelectedWordForQuestion,
                                options: orderNewDataOption,
                            });
                        }
                    }
                };

                return (
                    <ContainerOptions marginTop="10px" style={{ width: '49%' }}>
                        {RenderInputsOptions(`Opção ${indexZero}${indexFormat}`, item.option, onChangeOption)}
                    </ContainerOptions>
                );
            });
        }

        return null;
    };

    const RenderAllItems = () => {
        if (allMenuItems.ids.length) {
            return allMenuItems.ids.slice(0, 4).map((idSelected: any) => (
                <MenuItem value={idSelected}>{idSelected}</MenuItem>
            ));
        }
        return null;
    };

    const EndIcon = () => (
        <Send />
    );

    const RenderIconGoBack = () => (
        <NavigateBefore />
    );

    return (
        <>
            <ContainerOptions>
                <TitleOption width="100%">Criação da Atividade - Escolha a palavra/expressão para responder a pergunta</TitleOption>
            </ContainerOptions>
            {RenderInputsTitles('Título da atividade', taskSelectedWordForQuestion.title, onChangeTitle)}
            {RenderInputsTitles('Subtítulo da atividade', taskSelectedWordForQuestion.subtitle, onChangeSubtitle)}
            {RenderInputsTitles('Pergunta da atividade', taskSelectedWordForQuestion.question, onChangeQuestion)}
            <FormControl style={adjustWidthSelectedActivities}>
                <InputLabel>Quantidade</InputLabel>
                <Select value={taskSelectedWordForQuestion.target} onChange={onChangeTarget}>
                    {RenderAllItems()}
                </Select>
            </FormControl>
            <ContainerOptions marginTop="10px">
                {RenderInputsBody()}
            </ContainerOptions>
            <ContainerOptions marginTop="10px" width="50%">
                {RenderSelectedCorrectOptions(false)}
                {RenderSelectedCorrectOptions(true)}
            </ContainerOptions>
            <ContainerOptions marginTop="40px">
                <Button
                    color="primary"
                    startIcon={RenderIconGoBack()}
                    onClick={BackScreenModal}
                    variant="contained"
                >
                    Voltar
                </Button>
                <Button
                    color={validationBackground()}
                    disabled={validationDisabled()}
                    endIcon={EndIcon()}
                    onClick={CreateTask}
                    variant="contained"
                >
                    {taskSelectedWordForQuestion?.id ? 'Editar Atividade' : 'Criar Atividade'}
                </Button>
            </ContainerOptions>
        </>
    );
};

export default TaskSelectedWordForQuestion;
